import { trackingTiers } from '../../tracking';
import { TransferAmplitudeEventProperties } from '@wetransfer/transfer/modules/analytics/AnalyticsTypes';
import { filterUndefinedProperties } from '@wetransfer/transfer/modules/analytics/helpers';
import {
  TRANSFER_TYPES,
  TRANSFER_TYPES_IDS,
  TransferTypeId,
} from '@wetransfer/transfer/transfer-bundle/constant/transfer-types';

const action = 'Transfer Downloaded';

type TransferTypeEventProperty = 'Email' | 'Link';

const getTransferTypeEventProperty = (type: TRANSFER_TYPES) =>
  type === 'link' ? 'Link' : 'Email';

export const getTransferTypeById = (
  transferTypeId: TransferTypeId
): TRANSFER_TYPES => TRANSFER_TYPES_IDS[transferTypeId];

export const getBillingInterval = (
  tier: trackingTiers,
  interval: string
): 'Yearly' | 'Monthly' | null => {
  let billingPeriod: 'Yearly' | 'Monthly' | null = null;

  if (tier !== 'free') {
    billingPeriod = interval === 'year' ? 'Yearly' : 'Monthly';
  }

  return billingPeriod;
};

interface AmplitudeDownloadEvent {
  action: string;
  additionalProperties: {
    'Transfer Type': TransferTypeEventProperty;
    'File Size in Bytes'?: number;
    'Download Type': 'Full' | 'Partial';
    'Number of Files': number;
    'Wallpaper Number'?: TransferAmplitudeEventProperties['wallpaperNumber'];
    'Wallpaper Type'?: TransferAmplitudeEventProperties['wallpaperType'];
    'Wallpaper File'?: TransferAmplitudeEventProperties['wallpaperFileType'];
    'Wallpaper Source'?: TransferAmplitudeEventProperties['wallpaperSource'];
    Price?: number;
  };
  groups: {
    'Transfer ID': string;
  };
}

export const getDownloadFullEvent = (
  transferType: TRANSFER_TYPES,
  numberOfFiles: number,
  transferId: string,
  fileSizeInBytes?: number,
  wallpaperNumber?: TransferAmplitudeEventProperties['wallpaperNumber'],
  wallpaperType?: TransferAmplitudeEventProperties['wallpaperType'],
  wallpaperFileType?: TransferAmplitudeEventProperties['wallpaperFileType'],
  wallpaperSource?: TransferAmplitudeEventProperties['wallpaperSource'],
  price?: number
): AmplitudeDownloadEvent => ({
  action,
  additionalProperties: {
    'Transfer Type': getTransferTypeEventProperty(transferType),
    'File Size in Bytes': fileSizeInBytes,
    'Download Type': 'Full',
    'Number of Files': numberOfFiles,
    ...filterUndefinedProperties({
      'Wallpaper Number': wallpaperNumber,
      'Wallpaper Type': wallpaperType,
      'Wallpaper File': wallpaperFileType,
      'Wallpaper Source': wallpaperSource,
      Price: price,
    }),
  },
  groups: {
    'Transfer ID': transferId,
  },
});

export const getDownloadPartialEvent = (
  transferType: TRANSFER_TYPES,
  transferId: string,
  fileSizeInBytes?: number,
  wallpaperNumber?: TransferAmplitudeEventProperties['wallpaperNumber'],
  wallpaperType?: TransferAmplitudeEventProperties['wallpaperType'],
  wallpaperFileType?: TransferAmplitudeEventProperties['wallpaperFileType'],
  wallpaperSource?: TransferAmplitudeEventProperties['wallpaperSource'],
  price?: number
): AmplitudeDownloadEvent => ({
  action,
  additionalProperties: {
    'Transfer Type': getTransferTypeEventProperty(transferType),
    'File Size in Bytes': fileSizeInBytes,
    'Download Type': 'Partial',
    'Number of Files': 1,
    ...filterUndefinedProperties({
      'Wallpaper Number': wallpaperNumber,
      'Wallpaper Type': wallpaperType,
      'Wallpaper File': wallpaperFileType,
      'Wallpaper Source': wallpaperSource,
      Price: price,
    }),
  },
  groups: {
    'Transfer ID': transferId,
  },
});
